import { render, staticRenderFns } from "./MoreTitle.vue?vue&type=template&id=0360732e&scoped=true"
import script from "./MoreTitle.vue?vue&type=script&lang=js"
export * from "./MoreTitle.vue?vue&type=script&lang=js"
import style0 from "./MoreTitle.vue?vue&type=style&index=0&id=0360732e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0360732e",
  null
  
)

export default component.exports